export default "__VITE_ASSET__CFOrUR$u__"